
export default function AboutRaissa() {
  const credentials = [
    { icon: 'ri-medal-fill', text: 'Atleta Wellness Certificada' },
    { icon: 'ri-user-heart-fill', text: 'Personal Trainer Especializada' },
    { icon: 'ri-trophy-fill', text: '+300 Mulheres Transformadas' },
    { icon: 'ri-heart-pulse-fill', text: 'Especialista em Treino Feminino' }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-purple-50 to-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4 font-montserrat">
            Quem Vai Te Guiar Nessa <span className="text-purple-600">Transformação</span>
          </h2>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative z-10">
              <img
                src="https://static.readdy.ai/image/557dfd3dbeb95a5202c98a2c6d1e7295/9d202fb8b655f84733838ab22904b1da.jpeg"
                alt="Raíssa Bernardo - Atleta Wellness e Personal Trainer"
                className="w-full max-w-md mx-auto rounded-2xl shadow-2xl object-cover"
              />
              
              {/* Floating Badge */}
              <div className="absolute -top-4 -right-4 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-full p-4 shadow-lg">
                <i className="ri-award-fill text-2xl"></i>
              </div>
              
              {/* Signature */}
              <div className="absolute -bottom-6 left-1/2 transform -translate-x-1/2 bg-white rounded-xl p-4 shadow-lg">
                <div className="text-center">
                  <div className="font-pacifico text-purple-600 text-xl">Raíssa Bernardo</div>
                  <div className="text-sm text-gray-600 font-poppins">Atleta Wellness</div>
                </div>
              </div>
            </div>
            
            {/* Background Decoration */}
            <div className="absolute inset-0 bg-gradient-to-br from-purple-200 to-pink-200 rounded-2xl transform -rotate-6 -z-10"></div>
          </div>
          
          {/* Content */}
          <div className="space-y-8">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6 font-montserrat">
                Olá, eu sou a <span className="text-purple-600">Raíssa!</span>
              </h3>
              
              <div className="space-y-4 text-lg text-gray-700 leading-relaxed font-inter">
                <p>
                  Sou formada em <strong>Educação Física</strong>, <strong>personal trainer</strong> e <strong>atleta de fisiculturismo</strong> na categoria <strong className="text-purple-600">Wellness</strong>.
                </p>
                
                <p>
                  A musculação sempre fez parte da minha vida — primeiro como <strong>paixão</strong>, depois como <strong>propósito</strong>.
                </p>
                
                <p>
                  Ao longo dos anos, vivi na prática como a musculação pode transformar <strong>corpo, mente e autoestima</strong> de uma mulher. Por isso, escolhi dedicar minha carreira <strong>exclusivamente ao atendimento feminino</strong>: entender seus limites e te mostrar o seu potencial.
                </p>
                
                <p>
                  Hoje, uno minha formação, minha vivência como atleta e minha experiência como personal trainer para ajudar outras mulheres a treinarem com <strong className="text-purple-600">segurança, consciência e resultado</strong>.
                </p>
                
                <p className="text-purple-600 font-semibold">
                  Esse é o meu caminho — e é um privilégio guiar outras mulheres no delas.
                </p>
              </div>
            </div>
            
            {/* Credentials */}
            <div className="grid grid-cols-2 gap-4">
              {credentials.map((credential, index) => (
                <div
                  key={index}
                  className="flex items-center space-x-3 bg-white rounded-xl p-4 shadow-md border border-purple-100"
                >
                  <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
                    <i className={`${credential.icon} text-purple-600`}></i>
                  </div>
                  <span className="text-sm font-medium text-gray-800 font-poppins">
                    {credential.text}
                  </span>
                </div>
              ))}
            </div>
            
            {/* Social Proof */}
            <div className="flex items-center space-x-6">
              <div className="text-center">
                <div className="text-2xl font-bold text-purple-600 font-montserrat">10+</div>
                <div className="text-sm text-gray-600 font-poppins">Anos de Experiência</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-purple-600 font-montserrat">300+</div>
                <div className="text-sm text-gray-600 font-poppins">Alunas Transformadas</div>
              </div>
              <div className="text-center">
                <div className="text-2xl font-bold text-purple-600 font-montserrat">4.9</div>
                <div className="text-sm text-gray-600 font-poppins">Avaliação Média</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
